export class TransientError extends Error {
  constructor(public readonly message: string) {
    super();
  }

  toString() {
    return this.message;
  }
}

Object.defineProperty(TransientError.prototype, "name", {
  value: "TransientError",
});
